import API_URLS from "@constants/apiUrls";
import { api } from "services/customBaseQuery";

/**
 * RTK Query API endpoints for common application-wide operations.
 * Handles dashboard data, user profile, and logout functionality.
 */
const commonApi = api.injectEndpoints({
  endpoints: (build) => ({
    // Fetches dashboard data including corporate balance and name
    fetchDashboard: build.query<any, void>({
      query: () => ({
        url: API_URLS.DASHBOARD,
        method: "GET",
        credentials: "include",
      }),
    }),

    // Fetches user profile data for the authenticated user
    fetchProfile: build.query<any, void>({
      query: () => ({
        url: API_URLS.USER_PROFILE,
        method: "GET",
        credentials: "include",
      }),
    }),

    // Logs out the current user by invalidating their session
    logoutUser: build.mutation<any, void>({
      query: () => ({
        url: API_URLS.LOG_OUT,
        method: "POST",
        credentials: "include",
      }),
    }),
  }),
});

export const {
  useFetchDashboardQuery,
  useFetchProfileQuery,
  useLogoutUserMutation,
} = commonApi;

export default commonApi;